import GLU from '../glu2.js/src/index';

class HereAutocompleteApi extends GLU.Api {
  constructor(endpoint) {
    super(endpoint);

    this.createApiActions({
      name: 'autocomplete',
      method: GLU.Api.Get,
      path: '/autocomplete',
      credentials: false,
    });
  }
}

export default HereAutocompleteApi;
